import axios from "axios";
import { baseUrl, buildQuery } from "../config/api-config";

const base = `${baseUrl}`;

export function addCaseUsers(token, caseId, data) {
  return axios.post(`${baseUrl}/case/${caseId}/users`, data, {
    headers: {
      authorization: token,
    },
  });
}

export function getCaseUsers(token, caseId) {
  return axios.get(`${baseUrl}/case/${caseId}/users`, {
    headers: {
      authorization: token,
    },
  });
}
